$(function () {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});
function sticky_relocate() {
  var window_top = $(window).scrollTop();
  if (window_top > 10) {
    $("#Navigation").addClass("stick-header stick-inner-header");
  } else {
    $("#Navigation").removeClass("stick-header stick-inner-header");
  }
}
$(document).ready(function () {
  $(".silder-product").owlCarousel({
    loop: false,
    margin: 0,
    autoplay: false,
    nav: false,
    dots: false,
    autoplayTimeout: 2000,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.5,
        autoplay: true,
        loop: true,
        nav: false,
      },
      600: {
        items: 3,
        autoplay: true,
        loop: true,
        nav: false,
      },
      1000: {
        items: 3,
      },
    },
  });
});

$(document).ready(function () {
  $(".btn-nav").on("click tap", function (event) {
    event.stopPropagation();
    $(".nav-container").toggleClass("showNav hideNav").removeClass("hidden");
    $("body").toggleClass("on").removeClass("hideNav");
    $(this).toggleClass("animated");
  });
  $(".nav-container").on("click", function (event) {
    event.stopPropagation();
  });
  $("body:not('.nav-container')").click(function () {
    $(".nav-container").addClass("hideNav");
    $(".nav-container").removeClass("showNav");
    $("body").removeClass("on");
  });

  $(".ep-icon-item").click(function () {
    $(".drawer-popup").addClass("active");
    $("body").addClass("drawer-active");
  });

  $(".drawer-close, .drawer-overlay").click(function () {
    $(".drawer-popup").removeClass("active");
    $("body").removeClass("drawer-active");
  });

  $("ul.tabs .tab-link").click(function () {
    var tab_id = $(this).attr("data-tab");
    $("ul.tabs .tab-link").removeClass("current");
    $(".tab-content").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  $("ul.v-tabs .v-tab-link:first-child").addClass("current");
  $(".v-tab-content:first-child").addClass("current");

  $(".tab-link").click(function () {
    $("ul.v-tabs .v-tab-link").removeClass("current");
    $(".v-tab-content").removeClass("current");
    $("ul.v-tabs .v-tab-link:first-child").addClass("current");
    $(".v-tab-content:first-child").addClass("current");
  });

  $("ul.v-tabs .v-tab-link").click(function () {
    var tab_id = $(this).attr("data-tab");
    $("ul.v-tabs .v-tab-link").removeClass("current");
    $(".v-tab-content").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    $("#" + tab_id).addClass("current mobile-current");
    $(".drawer-popup .tab-content").scrollTop(0);
  });

  $(".back-inner-tab").click(function () {
    $(this).parents().removeClass("mobile-current");
  });
  $(".drawer-popup ul.tabs li:not(.drawer-close )").click(function () {
    $(".drawer-popup ul.tabs li").toggleClass("m-current");
  });
});
